const enUS = {
  translation: {
    // Navigation
    nav: {
      aiOs: 'AI OS',
      decision: 'Decision',
      execution: 'Execution',
      monitor: 'Monitor',
      opportunityRadar: 'Opportunity Radar',
      projects: 'Projects',
      community: 'Community',
      launches: 'Launches',
      life: 'Life',
      shopping: 'Shopping',
      services: 'Services',
      business: 'Business',
      analytics: 'Analytics',
      memory: 'Memory',
      settings: 'Settings',
      new: 'NEW',
    },
    // Common buttons
    common: {
      login: 'Login',
      create: 'Create',
      messages: 'Messages',
      language: 'Language',
    },
    // Model selector
    model: {
      label: 'Model',
      switchSuccess: 'Switched to model: {{name}}',
      models: {
        gpt4o: 'GPT-4o',
        claude35Sonnet: 'Claude-3.5-Sonnet',
        tongyi: 'Tongyi Qianwen',
        deepseek: 'DeepSeek',
        fastgpt: 'FastGPT',
      },
    },
    // Page titles
    page: {
      aiCommandCenter: 'AI Command Center',
      home: 'Home',
      projects: 'Projects',
      settings: 'Settings',
    },
    // Status
    status: {
      online: '{{count}} Agents online',
      offline: 'Offline',
      running: 'Running',
      loading: 'Loading...',
      error: 'Error',
    },
  },
};

export default enUS;
